import type { SessionEndpoints } from './endpointManifest';
import { useSessionEndpoints } from './SessionEndpointsContext';

// The organization-bound endpoint surface for components inside
// OrganizationScope. The binding is memoized per committed organization, and
// the scope key remounts the subtree on a switch, so a captured surface (in
// a closure, through a dialog, across awaits) is correct for its mount's
// entire lifetime - the identity travels with the call, never resolved
// ambiently at dispatch.
export const useEndpoints = (): SessionEndpoints => {
  return useSessionEndpoints();
};
